import { Grid, Paper } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import * as GrindLookup from '../library/GrindLookup';
import * as GrindTables from '../library/GrindTables';
import Fitter from '../classes/Fitter';
import grind_divider_large from '../images/grind-divider-large.svg';
import grind_divider_small from '../images/grind-divider-small.svg';
import grind_divider_flag from '../images/grind-divider-flag.svg';
import grind_d_sm11 from '../images/SM11-Grinds-D.jpg';
import grind_f_sm11 from '../images/SM11-Grinds-F.jpg';
import grind_k_sm11 from '../images/SM11-Grinds-K.jpg';
import grind_m_sm11 from '../images/SM11-Grinds-M.jpg';
import grind_s_sm11 from '../images/SM11-Grinds-S.jpg';
import grind_t_sm11 from '../images/SM11-Grinds-T.jpg';

export default function FittingYourGrinds(props: any) {
    const grindRecommendations = props.grindRecommendations as GrindLookup.LoftGrindRecommendation[];
    const intl = useIntl();
    const fitter = props.fitter as Fitter;
    const showGapping = props.showGapping as boolean;
    const distanceUnits = props.distanceUnits === "Meters" ? " " + intl.formatMessage({ id: "now.hitting.meters" }) : " " + intl.formatMessage({ id: "now.hitting.yds" });
    const usingSm11 = GrindTables.showSM11(fitter.showSm11);

    return (
        <Paper sx={{ marginLeft: '0px' }}>
            <Grid container className='row' sx={{ marginTop: '10px !important', marginBottom: '10px' }}>
            </Grid>
            {grindRecommendations.map((grind, grindIx) => {
                return (
                    <div key={grindIx}>
                        {grind.grindWeightings.map((weighting, weightingIx) => {

                            if (weightingIx == 0) {
                                return (
                                    <div key={weightingIx}>
                                        <Grid container className='row' sx={{ marginTop: '0px !important', paddingTop: '5px' }}>
                                            <Grid item xs={12}>
                                                <Grid container>
                                                    <Grid item xs={7}>
                                                        <Grid container>
                                                            <Grid item xs={12}>
                                                                <div style={{ float: 'left', fontSize: 'xx-large', marginLeft: '13px', marginTop: '25px' }}>{grind.loft}{`${weighting.weightPercent != 0 ? "." + weighting.bounce : ""}`}    </div> <div style={{ float: 'left', marginLeft: '10px', fontWeight: '600', marginTop: '25px', fontSize: 'xx-large' }}>{`${weighting.weightPercent != 0 ? weighting.grind : "--"}`}</div>
                                                            </Grid>
                                                            {showGapping &&
                                                                <Grid item xs={12} sx={{ textAlign: 'left', marginLeft: '15px' }}>
                                                                    {`${grind.averageCarryDistance > 0 ? grind.averageCarryDistance + distanceUnits : ""}`}
                                                                </Grid>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item sm={5} sx={{ paddingLeft: { lg: '15px', xs: '0px' } }}>
                                                        {usingSm11 && (
                                                            <>
                                                                {weighting.grind == "D" && <img style={{ float: 'left', height: '95px' }} src={grind_d_sm11}></img>}
                                                                {weighting.grind == "F" && <img style={{ float: 'left', height: '95px' }} src={grind_f_sm11}></img>}
                                                                {weighting.grind == "K" && <img style={{ float: 'left', height: '95px' }} src={grind_k_sm11}></img>}
                                                                {weighting.grind == "M" && <img style={{ float: 'left', height: '95px' }} src={grind_m_sm11}></img>}
                                                                {weighting.grind == "S" && <img style={{ float: 'left', height: '95px' }} src={grind_s_sm11}></img>}
                                                                {weighting.grind == "T" && <img style={{ float: 'left', height: '95px' }} src={grind_t_sm11}></img>}
                                                            </>
                                                        )}

                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {showGapping && grind.gapSmall &&
                                            <Grid container sx={{ minHeight: '10px', marginTop: '0px' }}>
                                                <img src={grind_divider_small} style={{ height: '2px', width: '71px', marginTop: '10px', marginLeft: '15px' }}></img>
                                                <span style={{ marginLeft: '7px', marginRight: '8px' }}><img src={grind_divider_flag}></img> <FormattedMessage id="now.hitting.small" /></span>
                                                <img src={grind_divider_small} style={{ height: '2px', width: '71px', marginTop: '10px' }}></img>
                                            </Grid>
                                        }
                                        {showGapping && grind.gapLarge &&
                                            <Grid container sx={{ minHeight: '10px', marginTop: '0px' }}>
                                                <img src={grind_divider_small} style={{ height: '2px', width: '71px', marginTop: '10px', marginLeft: '15px' }}></img>
                                                <span style={{ marginLeft: '7px', marginRight: '8px' }}><img src={grind_divider_flag}></img> <FormattedMessage id="now.hitting.large" /></span>
                                                <img src={grind_divider_small} style={{ height: '2px', width: '71px', marginTop: '10px' }}></img>
                                            </Grid>
                                        }
                                        {grind.gapLine &&
                                            <Grid container sx={{ minHeight: '10px', marginTop: '10px', paddingLeft: '15px', paddingRight: '15px' }}>
                                                <img style={{ height: '2px', width: '100%' }} src={grind_divider_large}></img>
                                            </Grid>
                                        }

                                    </div>
                                )
                            }
                        })
                        }

                    </div>
                )
            })
            }
            <Grid container className='row' sx={{ marginTop: '10px !important' }}>
            </Grid>
        </Paper>
    )
}
